import type { FC } from 'react'
import { Mail, MailIcon } from 'lucide-react'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { CopyButton } from '../global/copy-button'

interface SalesDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const SalesDialog: FC<SalesDialogProps> = ({ open, onOpenChange }) => {
  const handleSendEmail = () => {
    window.location.href = 'mailto:sales@journeyid.com'
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Contact Sales</DialogTitle>
          <DialogDescription>
            Have questions or want to learn more about Journey? Our sales team is here to help!
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col self-auto w-full py-2 space-y-6">
          <div className="flex items-center space-x-3">
            <div className="bg-muted p-2.5 rounded-full">
              <Mail className="w-5 h-5 text-primary" />
            </div>
            <div className="flex flex-col">
              <span className="text-sm font-medium text-muted-foreground">Email us at</span>
              <div className="flex items-center space-x-2">
                <span className="font-semibold text-primary">sales@journeyid.com</span>
                <CopyButton text="sales@journeyid.com" small />
              </div>
            </div>
          </div>

          <Button className="relative group" onClick={handleSendEmail}>
            <MailIcon className="w-4 h-4 ml-2 transition-transform group-hover:-translate-x-1" />
            <span>Send Email Now</span>
          </Button>
        </div>
        <span className="block w-full mt-2 text-xs text-center text-muted-foreground">
          Looking for help instead? <br /> Contact support@journeyid.com
        </span>
      </DialogContent>
    </Dialog>
  )
}

export default SalesDialog
